/**
 * CDN image URLs served from Cloudflare R2.
 */

const CDN_BASE = "https://images.abbashouse.org";

function cdn(path: string): string {
  return `${CDN_BASE}/${path}`;
}

export const facility1 = cdn("assets/facility-1.webp");
export const facility2 = cdn("assets/facility-2.webp");
export const facility3 = cdn("assets/facility-3.webp");
export const facility4 = cdn("assets/facility-4.webp");
export const facility5 = cdn("assets/facility-5.webp");

// Responsive srcset helper. We uploaded -640w and -960w variants alongside the
// 1280w default, so mobile pulls ~60 KB instead of ~135 KB.
export function facilitySrcSet(base: string): string {
  const stem = base.replace(/\.webp$/, "");
  return `${stem}-640w.webp 640w, ${stem}-960w.webp 960w, ${base} 1280w`;
}

// Header logo served as bundled PNG for maximum crispness
import logoHeaderPng from "@/assets/logo-header.png";
export const logoBlack = logoHeaderPng;

export const logoWhite = cdn("assets/logo-white.webp");

// Hero image (used in Home.tsx with preload)
export const heroImage = cdn("assets/facility-1.webp");
export const heroImageSrcSet = facilitySrcSet(heroImage);
